"use client";

import { ErrorPageProps } from "@/lib/error-page-props";
import { RootErrorNavButton } from "@/components/nav-button/root-error-nav-button";
import StatusContainer from "../components/containers/status-container";
import { montserrat } from "./fonts";
import { Logo } from "@/components/logo";

export const runtime = "edge";

export default function ErrorPage({}: ErrorPageProps) {
  return (
    <html className="h-svh" lang="en">
      <body
        className={`${montserrat.variable} flex h-full w-full flex-col justify-self-center pt-0`}
      >
        <div className="flex h-full flex-col md:gap-4">
          <div>
            <div className="flex justify-center align-middle">
              <div className="mx-auto">
                <Logo />
              </div>{" "}
            </div>
          </div>
          <div className="md:flex md:flex-col">
            <main>
              <StatusContainer
                title="Error 500"
                heading="Oops, something went wrong"
                desc="Well this is embarrassing. Something has gone wrong on our end. Please try again later."
                button={<RootErrorNavButton />}
              />
            </main>
          </div>
        </div>
      </body>
    </html>
  );
}
